var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.loadingServerInfo
        ? _c("Spinner", { attrs: { lg: "", center: "" } })
        : _vm._e(),
      _vm._v(" "),
      !_vm.busy && !_vm.serverInfo && _vm.errorMessage
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _vm._v(
              "\n\t\tError loading BlackLab info, try refreshing the page.\n\t\t"
            ),
            _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
          ])
        : _vm.successMessage
        ? _c("div", { staticClass: "alert alert-success" }, [
            _c(
              "a",
              {
                staticClass: "close",
                attrs: {
                  href: "#",
                  "data-dismiss": "alert",
                  "aria-label": "close",
                },
                on: {
                  click: function ($event) {
                    _vm.successMessage = ""
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._v("\n\t\t" + _vm._s(_vm.successMessage) + "\n\t"),
          ])
        : _vm.errorMessage
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c(
              "a",
              {
                staticClass: "close",
                attrs: { href: "#", "aria-label": "close" },
                on: {
                  click: function ($event) {
                    _vm.errorMessage = ""
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._v("\n\t\t" + _vm._s(_vm.errorMessage) + "\n\t"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.serverInfo
        ? [
            !_vm.publicCorpora.length &&
            !_vm.loadingCorpora &&
            !_vm.canCreateCorpus
              ? _c("div", { staticClass: "cf-panel cf-panel-lg" }, [
                  _c("h2", [_vm._v("No corpora available")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "No corpora have been added to BlackLab. Corpora will appear here when when they become available."
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.publicCorpora.length
              ? _c("CorpusTable", {
                  attrs: {
                    loading: _vm.loadingCorpora,
                    corpora: _vm.publicCorpora,
                    formats: _vm.formats,
                    title: "Public corpora",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.loggedIn
              ? _c("CorpusTable", {
                  attrs: {
                    title: "Your corpora",
                    isPrivate: "",
                    loading: _vm.loadingCorpora,
                    corpora: _vm.privateCorpora,
                    formats: _vm.formats,
                    canCreateCorpus: _vm.canCreateCorpus,
                  },
                  on: {
                    share: _vm.doShareCorpus,
                    upload: _vm.doUploadCorpus,
                    delete: _vm.doDeleteCorpus,
                    create: _vm.doCreateCorpus,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.loggedIn
              ? _c("FormatsTable", {
                  attrs: {
                    formats: _vm.privateFormats,
                    loading: _vm.loadingFormats,
                  },
                  on: {
                    create: _vm.doCreateFormat,
                    edit: _vm.doEditFormat,
                    delete: _vm.doDeleteFormat,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.modal === "create-format"
              ? _c("ModalCreateFormat", {
                  attrs: {
                    publicFormats: _vm.publicFormats,
                    privateFormats: _vm.privateFormats,
                    loading: _vm.loadingFormats,
                    format: _vm.format,
                  },
                  on: {
                    create: _vm.refreshFormats,
                    success: _vm.success,
                    error: _vm.error,
                    close: _vm.close,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.modal === "create-corpus"
              ? _c("ModalCreateCorpus", {
                  attrs: {
                    publicFormats: _vm.publicFormats,
                    privateFormats: _vm.privateFormats,
                    loading: _vm.loadingFormats,
                    user: _vm.serverInfo.user,
                  },
                  on: {
                    create: _vm.refreshCorpora,
                    success: _vm.success,
                    error: _vm.error,
                    close: _vm.close,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.modal === "upload"
              ? _c("ModalUpload", {
                  attrs: { corpus: _vm.corpus, formats: _vm.formats },
                  on: {
                    indexing: _vm.refreshCorpus,
                    success: _vm.success,
                    error: _vm.error,
                    close: _vm.close,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.modal === "share-corpus"
              ? _c("ModalShareCorpus", {
                  attrs: { corpus: _vm.corpus },
                  on: {
                    success: _vm.success,
                    error: _vm.error,
                    close: _vm.close,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.modal === "confirm"
              ? _c(
                  "Modal",
                  {
                    attrs: {
                      closeMessage: "Cancel",
                      confirmMessage: "Delete",
                      confirmClass: "btn-danger",
                    },
                    on: { confirm: _vm.confirmAction, close: _vm.close },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("h4", {
                                staticClass: "modal-title",
                                domProps: {
                                  innerHTML: _vm._s(_vm.confirmTitle),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      766151978
                    ),
                  },
                  [
                    _vm._v(" "),
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.confirmMessage) },
                    }),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }